<div class="form-group mt-4">
  <label class="col-form-label text-[14px]!"><strong>{{ 'LOGIN.PIN_LABEL' | translate }}</strong></label>
  <div class="pin">
    <code-input
      #codeInput
      class="code-input"
      (codeCompleted)="credentialSubmit.emit($event)"
      [codeLength]="4"
      [isCodeHidden]="true"
      id="codeInput"
    >
    </code-input>
  </div>
  @if (incorrectPassword()) {
  <app-alert class="mt-4!" (closed)="dismissIncorrectPassword.emit()" type="danger">
    {{ active() === 1 ? ('MESSAGES.ERRORS.INCORRECT_EMAIL_OR_PASSWORD' | translate) :
    ('MESSAGES.ERRORS.INCORRECT_MOBILE_OR_PASSWORD' | translate) }}
  </app-alert>
  } @if (errors().size) {
  <app-alert class="mt-4!" (closed)="clearErrors.emit()" type="danger">
    @for (error of errors(); track $index) {
    <span>{{ error }}</span><br />
    }
  </app-alert>
  }
</div>
